import React from 'react';
import Classes from './Post.module.css';

const Post = props => {
  return (
    <a href={props.link} target="_blank" className={Classes.Post}>
      <p>{props.children}</p>
      <img src={props.image} alt="" height="auto" width="200" />
    </a>
  );
};

export default Post;
